import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import ProductCostSection from '../../../FillProductDetailsDrawer/components/ProductCostSection';
import ProductOtherSection from '../../../FillProductDetailsDrawer/components/ProductOtherSection';

interface CarrierDetailsStepProps {
  carrier: Product;
  isLoading: boolean;
}
const CarrierDetailsStep: React.FC<CarrierDetailsStepProps> = ({
  carrier,
  isLoading
}) => {
  if (isLoading)
    return (
      <div className="pt-128px">
        <LoadingSpinner />
      </div>
    );

  if (!carrier) return null;

  return (
    <div className="px-8">
      <div className="cwf-product-drawer-form-content">
        <ProductCostSection product={carrier} />
        <ProductOtherSection />
      </div>
    </div>
  );
};

export default CarrierDetailsStep;
